import { render, staticRenderFns } from "./ColorsGradient.vue?vue&type=template&id=2f4bf6fa"
import script from "./ColorsGradient.vue?vue&type=script&lang=js"
export * from "./ColorsGradient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports